export default __webpack_public_path__ + "static/media/S0020_6.12_TST_bands.1702919220000.1428b5d0.jpg";